<template>
  <div class="relation-info-item">
    <div class="label">{{ options.label }}</div>
    <div class="text" :class="options.extraClass">
      {{
        `${options.beforeTip}${
          options.needFormat
            ? options.format(formdata[options.field])
            : handleEmpty(formdata[options.field])
        }`
      }}
    </div>
  </div>
</template>
<script lang="ts">
import { Vue, Prop, Component } from 'vue-property-decorator';
import { IBillingDetail } from '../../../billingSystem';
interface IFormOptions {
  label: string;
  field: string;
  needFormat: boolean;
  extraClass: string;
  beforeTip: string;
  format: Function;
}
@Component({})
export default class FormItem extends Vue {
  @Prop({})
  formdata!: IBillingDetail;
  @Prop({
    default: {
      label: '',
      field: '',
      needFormat: false,
      extraClass: '',
      beforeTip: '',
      format: () => {},
    },
  })
  options!: IFormOptions;

  handleEmpty(value: string) {
    if (!value) return '-';
    return value;
  }
}
</script>

<style lang="scss" scoped>
@import '../../../style/index.scss';
.relation-info-item {
  display: flex;
  margin-bottom: 32px;
  color: $_label_color;
  font-size: 28px;
  .label {
    min-width: 112px;
    margin-right: 32px;
  }
  .text {
    color: $_base_color;
    font-family: $_reg_famliy;
  }
  .text.billing-money {
    color: $_base_color;
    font-weight: 500;
    font-size: 28px;
    font-family: $_reg_famliy;
  }
}
</style>